import * as L from "leaflet";
import * as React from "react";
import { style } from "typestyle";
import { connect } from "react-redux";
import { IStoreState, getDeprecatedUIState } from "../../../redux/rootReducer";
import { IDeprecatedUIState } from "../../../redux/modules/ui/reducer";
import { IGcpAppDispatchProp } from "../../../redux/store";
import { userClicksSidebarVisibilityControl } from "../../scenarios";

const rootCN = style({
  pointerEvents: "auto",
  cursor: "pointer",
  background: "white",
  padding: "8px",
  borderRadius: "8px",
  boxShadow: "0 1px 2px 0 rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
});

interface IProps extends IGcpAppDispatchProp {
  uiState: IDeprecatedUIState;
}
const SidebarVisibilityControl = ({ uiState, dispatch }: IProps) => {
  if (uiState.sidebarIsVisible || !L.Browser.mobile) {
    return null;
  }

  return (
    <div
      className={rootCN}
      onClick={() => {
        dispatch(userClicksSidebarVisibilityControl());
      }}
    >
      <img src="icon-menu.svg" />
    </div>
  );
};

export default connect((state: IStoreState) => ({
  uiState: getDeprecatedUIState(state),
}))(SidebarVisibilityControl);
